<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colspan"
      :get-action="queryApi"
      :auto-fetch="false"
      :rules="queryRules"
      :btn-search-style="trialSearchButtonStyle"
      :before-reset-search="beforeResetSearch"
      :before-query-search="beforeQuerySearch"
      :serial="false"
      :selection="false"
      :is-list="true"
      :height="trialTableHeight"
      @afterFetchData="afterFetchData"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <!-- 费用项 -->
        <el-col :span="colspan">
          <el-form-item :label="$t('QuotationCenter.feeItem')" prop="feeItems">
            <BjSelectLov v-model="queryParams.feeItems" multiple collapse-tags :placeholder="$t('QuotationCenter.feeItem')" :option-list="QUOTATION_FEE_ITEM" />
          </el-form-item>
        </el-col>
        <!-- 国家 -->
        <el-col :span="colspan">
          <el-form-item :label="$t('QuotationCenter.components.country')" prop="country">
            <BjSelectLov v-model="queryParams.country" :placeholder="$t('QuotationCenter.components.country')" :option-list="COUNTRY_NAME_AND_TWOCODE" />
          </el-form-item>
        </el-col>
        <!-- 省份 -->
        <el-col :span="colspan">
          <el-form-item :label="$t('QuotationCenter.components.province')" prop="state">
            <el-input v-model="queryParams.state" :placeholder="$t('QuotationCenter.components.province')" />
          </el-form-item>
        </el-col>
        <!-- 城市 -->
        <el-col :span="colspan">
          <el-form-item :label="$t('QuotationCenter.components.city')" prop="city">
            <el-input v-model="queryParams.city" :placeholder="$t('QuotationCenter.components.city')" />
          </el-form-item>
        </el-col>
        <!-- 邮编 -->
        <el-col :span="colspan">
          <el-form-item :label="$t('QuotationCenter.components.postcode')" prop="postCode">
            <el-input v-model="queryParams.postCode" :placeholder="$t('QuotationCenter.components.postcode')" />
          </el-form-item>
        </el-col>
        <!-- 供应商 -->
        <el-col :span="colspan">
          <el-form-item :label="$t('QuotationCenter.supplier')" prop="supplierCode">
            <!-- <BjSelectLov v-model="queryParams.supplierCode" :placeholder="$t('QuotationCenter.supplier')" :option-list="supplierAllList" /> -->
            <el-input disabled v-model="$route.query.supplierName" :placeholder="$t('QuotationCenter.supplier')" />
          </el-form-item>
        </el-col>
        <!-- 物流渠道 -->
        <el-col :span="colspan">
          <el-form-item :label="$t('QuotationCenter.logisticsChannel')" prop="logisticsChannelCode">
            <!-- <BjSelectLov v-model="queryParams.logisticsChannelCode" :placeholder="$t('QuotationCenter.logisticsChannel')" :option-list="logisticsChannelAllList" /> -->
            <el-input disabled v-model="$route.query.logisticsChannelName" :placeholder="$t('QuotationCenter.logisticsChannel')" />
          </el-form-item>
        </el-col>
        <!-- 包裹类型 -->
        <el-col :span="colspan">
          <el-form-item :label="$t('QuotationCenter.packageType')" prop="packageType">
            <BjSelectLov v-model="queryParams.packageType" :placeholder="$t('QuotationCenter.packageType')" :option-list="QUOTATION_PACKAGE_TYPE" />
          </el-form-item>
        </el-col>
        <!-- 申报币种 -->
        <el-col :span="colspan">
          <el-form-item :label="$t('QuotationCenter.components.declaredCurrency')" prop="currency">
            <BjSelectLov v-model="queryParams.currency" :placeholder="$t('QuotationCenter.components.declaredCurrency')" :option-list="currencyList" />
          </el-form-item>
        </el-col>
        <!-- 金额 -->
        <el-col :span="colspan">
          <el-form-item :label="$t('QuotationCenter.amount')" prop="amount">
            <el-input v-model="queryParams.amount" :placeholder="$t('QuotationCenter.amount')" />
          </el-form-item>
        </el-col>
        <!-- 计费单位 -->
        <el-col :span="colspan">
          <el-form-item :label="$t('QuotationCenter.billingType')" prop="billingType">
            <BjSelectLov v-model="queryParams.billingType" multiple :placeholder="$t('QuotationCenter.billingType')" :option-list="QUOTATION_BILLING_TYPE" @change="handleBillingTypeChange" />
          </el-form-item>
        </el-col>
        <!-- 实重 -->
        <el-col :span="colspan">
          <el-form-item prop="weight">
            <template slot="label">
              <span class="trial-required-label">{{ $t('QuotationCenter.components.actualWeight') }}</span>
            </template>
            <el-input v-model="queryParams.weight" :placeholder="$t('QuotationCenter.components.actualWeight')">
              <template slot="append">kg</template>
            </el-input>
          </el-form-item>
        </el-col>
        <!-- 长 -->
        <el-col :span="colspan">
          <el-form-item prop="length">
            <template slot="label">
              <span :class="{ 'trial-required-label': isBillingTypeSelected(1) }">{{ $t('QuotationCenter.components.length') }}</span>
            </template>
            <el-input v-model="queryParams.length" :placeholder="$t('QuotationCenter.components.length')">
              <template slot="append">cm</template>
            </el-input>
          </el-form-item>
        </el-col>
        <!-- 宽 -->
        <el-col :span="colspan">
          <el-form-item prop="width">
            <template slot="label">
              <span :class="{ 'trial-required-label': isBillingTypeSelected(1) }">{{ $t('QuotationCenter.components.width') }}</span>
            </template>
            <el-input v-model="queryParams.width" :placeholder="$t('QuotationCenter.components.width')">
              <template slot="append">cm</template>
            </el-input>
          </el-form-item>
        </el-col>
        <!-- 高 -->
        <el-col :span="colspan">
          <el-form-item prop="height">
            <template slot="label">
              <span :class="{ 'trial-required-label': isBillingTypeSelected(1) }">{{ $t('QuotationCenter.components.height') }}</span>
            </template>
            <el-input v-model="queryParams.height" :placeholder="$t('QuotationCenter.components.height')">
              <template slot="append">cm</template>
            </el-input>
          </el-form-item>
        </el-col>
        <!-- 托盘 -->
        <el-col :span="colspan">
          <el-form-item prop="PalletsNum">
            <template slot="label">
              <span :class="{ 'trial-required-label': isBillingTypeSelected(2) }">{{ $t('QuotationCenter.components.Pallets') }}</span>
            </template>
            <el-input v-model="queryParams.PalletsNum" :disabled="!isBillingTypeSelected(2)" :placeholder="$t('QuotationCenter.components.Pallets')" />
          </el-form-item>
        </el-col>
        <!-- 票数 -->
        <el-col :span="colspan">
          <el-form-item prop="TicketsNum">
            <template slot="label">
              <span :class="{ 'trial-required-label': isBillingTypeSelected(3) }">{{ $t('QuotationCenter.components.Tickets') }}</span>
            </template>
            <el-input v-model="queryParams.TicketsNum" disabled :placeholder="$t('QuotationCenter.components.Tickets')" />
          </el-form-item>
        </el-col>
        <!-- 小时数 -->
        <el-col :span="colspan">
          <el-form-item prop="HoursNum">
            <template slot="label">
              <span :class="{ 'trial-required-label': isBillingTypeSelected(4) }">{{ $t('QuotationCenter.components.Hours') }}</span>
            </template>
            <el-input v-model="queryParams.HoursNum" :disabled="!isBillingTypeSelected(4)" :placeholder="$t('QuotationCenter.components.Hours')" />
          </el-form-item>
        </el-col>
        <!-- 件数 -->
        <el-col :span="colspan">
          <el-form-item prop="ItemsNum">
            <template slot="label">
              <span :class="{ 'trial-required-label': isBillingTypeSelected(5) }">{{ $t('QuotationCenter.components.Items') }}</span>
            </template>
            <el-input v-model="queryParams.ItemsNum" :disabled="!isBillingTypeSelected(5)" :placeholder="$t('QuotationCenter.components.Items')" />
          </el-form-item>
        </el-col>
        <!-- 次数 -->
        <el-col :span="colspan">
          <el-form-item prop="TimesNum">
            <template slot="label">
              <span :class="{ 'trial-required-label': isBillingTypeSelected(6) }">{{ $t('QuotationCenter.components.Times') }}</span>
            </template>
            <el-input v-model="queryParams.TimesNum" :disabled="!isBillingTypeSelected(6)" :placeholder="$t('QuotationCenter.components.Times')" />
          </el-form-item>
        </el-col>
      </template>

      <template v-slot:tableOperation>
        <el-col>
          <BjFrontendExport
            icon="el-icon-download"
            plain
            :label-list="exportLabelList"
            :rows="displayedRows || []"
            :file-name="`${$t('QuotationCenter.trialCalculation')}.csv`"
            :empty-text="$t('table.emptyText')"
          />
        </el-col>
      </template>

      <template v-slot:tableColumn>
        <template v-for="col in dropCols">
          <el-table-column
            :key="col.prop"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :sortable="col.sortable || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="{ row }">
              <template v-if="col.prop === 'feeItem'">{{ $t(QUOTATION_FEE_ITEM.bjGet(row.feeItem)) }}</template>
              <template v-else-if="col.prop === 'packageType'">{{ $t(QUOTATION_PACKAGE_TYPE.bjGet(row.packageType)) }}</template>
              <template v-else-if="col.prop === 'chargeUnit'">{{ $t(QUOTATION_CHARGE_UNIT.bjGet(row.billingType)) }}</template>
              <template v-else-if="col.prop === 'quotationAmount'">{{ row.quotationAmount }} {{ row.quotationCurrency }}</template>
              <template v-else-if="col.prop === 'standardAmount'">{{ row.standardAmount }} {{ row.standardCurrency }}</template>
              <template v-else>{{ row[col.prop] }}</template>
            </template>
          </el-table-column>
        </template>
      </template>

      <template v-slot:paginationBottom>
        <div class="trial-total">
          <span>{{ $t('QuotationCenter.components.totalAmount') }}:</span>
          <strong>{{ totalAmountText }}</strong>
        </div>
      </template>
    </BjPage>
  </div>
</template>

<script>
import { logisticApi } from '@/api';
import pageMiXin from '@/utils/page-mixin.js';
import {
  QUOTATION_FEE_ITEM,
  QUOTATION_PACKAGE_TYPE,
  QUOTATION_BILLING_TYPE,
  QUOTATION_CHARGE_UNIT,
  loadQuotationOptions,
} from '@/utils/quotationOptions';
import { COUNTRY_NAME_AND_TWOCODE } from '@/utils/statics';

const getDefaultQueryParams = routeId => ({
  supplierLogisticsQuoteId: routeId || '',
  packageType: '',
  weight: '',
  country: '',
  state: '',
  city: '',
  postCode: '',
  supplierCode: '',
  logisticsChannelCode: '',
  feeItems: QUOTATION_FEE_ITEM.map(item => item.value),
  // feeItems: [0],
  billingType: [],
  currency: 'AUD',
  amount: '',
  PalletsNum: '',
  TicketsNum: '',
  HoursNum: '',
  ItemsNum: '',
  TimesNum: '',
  length: '',
  width: '',
  height: '',
});

const POSITIVE_INTEGER_PATTERN = /^[1-9]\d*$/;
const NON_NEGATIVE_NUMBER_PATTERN = /^(0|[1-9]\d*)(\.\d+)?$/;
const CHINESE_ENGLISH_SPACE_PATTERN = /^[A-Za-z\u4e00-\u9fff ]*$/;
const ENGLISH_NUMBER_PATTERN = /^[A-Za-z0-9]*$/;
const BILLING_FIELD_MAP = {
  2: ['PalletsNum'],
  3: ['TicketsNum'],
  4: ['HoursNum'],
  5: ['ItemsNum'],
  6: ['TimesNum'],
};

export default {
  name: 'BusinessQuotationTrialCalculation',
  mixins: [pageMiXin],
  data() {
    return {
      colspan: 6,
      QUOTATION_FEE_ITEM,
      QUOTATION_PACKAGE_TYPE,
      QUOTATION_BILLING_TYPE,
      QUOTATION_CHARGE_UNIT,
      COUNTRY_NAME_AND_TWOCODE,
      queryApi: logisticApi.calculateQuote,
      trialSearchButtonStyle: {
        type: 'primary',
        textKey: 'QuotationCenter.trialCalculation',
      },
      queryParams: getDefaultQueryParams(this.$route.query.id),
      trialTableHeight: 360,
      supplierAllList: [],
      logisticsChannelAllList: [],
      currencyList: [
        { label: 'AUD', value: 'AUD' },
        { label: 'CNY', value: 'CNY' },
        { label: 'USD', value: 'USD' },
      ],
      displayedRows: null,
      isResettingSearch: false,
      labelList: [
        { label: this.$t('QuotationCenter.feeItem'), prop: 'feeItem', isCheck: true, disabled: false },
        { label: this.$t('QuotationCenter.logisticsChannel'), prop: 'logisticsChannelName', isCheck: true, disabled: false },
        { label: this.$t('QuotationCenter.chargeUnit'), prop: 'chargeUnit', isCheck: true, disabled: false },
        // { label: this.$t('QuotationCenter.components.specialGoodsType'), prop: 'specialGoodsTypeName', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('QuotationCenter.packageType'), prop: 'packageType', isCheck: true, disabled: false },
        { label: this.$t('QuotationCenter.components.quoteAmount'), prop: 'quotationAmount', isCheck: true, disabled: false },
        { label: this.$t('QuotationCenter.components.quoteSettlementWeight'), prop: 'settlementWeight', isCheck: true, disabled: false },
        { label: this.$t('QuotationCenter.components.localCurrencyAmount'), prop: 'standardAmount', isCheck: true, disabled: false, sortable: true, width: 160 },
        { label: this.$t('QuotationCenter.components.systemSettlementWeight'), prop: 'systemWeight', isCheck: true, disabled: false },
      ],
    };
  },
  computed: {
    exportLabelList() {
      const exportConfigs = {
        feeItem: { options: QUOTATION_FEE_ITEM, translate: true, optionFallback: 'raw' },
        packageType: { options: QUOTATION_PACKAGE_TYPE, translate: true, optionFallback: 'raw' },
        chargeUnit: { prop: 'billingType', options: QUOTATION_CHARGE_UNIT, translate: true, optionFallback: 'raw' },
        quotationAmount: { formatter: (value, row) => `${row.quotationAmount || ''}${row.quotationCurrency ? ` ${row.quotationCurrency}` : ''}` },
        standardAmount: { formatter: (value, row) => `${row.standardAmount || ''}${row.standardCurrency ? ` ${row.standardCurrency}` : ''}` },
      };
      return [
        ...this.labelList.map(column => exportConfigs[column.prop]
          ? { ...column, export: exportConfigs[column.prop] }
          : column),
        {
          label: this.$t('QuotationCenter.components.totalAmount'),
          prop: '__totalAmount',
          export: { formatter: (value, row, column, index) => index === this.displayedRows.length - 1 ? this.totalAmountText : '' },
        },
      ];
    },
    queryRules() {
      return {
        country: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        state: [{ validator: this.validatePattern(CHINESE_ENGLISH_SPACE_PATTERN, this.$t('formatErrorText')), trigger: 'blur' }],
        postCode: [{ validator: this.validatePattern(ENGLISH_NUMBER_PATTERN, this.$t('formatErrorText')), trigger: 'blur' }],
        billingType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        weight: [
          { validator: this.validateRequired, trigger: 'blur' },
          { validator: this.validateNumberDecimal(3, this.$t('QuotationCenter.components.maxThreeDecimals')), trigger: 'blur' },
        ],
        packageType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        length: [
          { validator: this.validateBillingRequired(1), trigger: 'blur' },
          { validator: this.validateNumberDecimal(2, this.$t('QuotationCenter.components.maxTwoDecimals')), trigger: 'blur' },
        ],
        width: [
          { validator: this.validateBillingRequired(1), trigger: 'blur' },
          { validator: this.validateNumberDecimal(2, this.$t('QuotationCenter.components.maxTwoDecimals')), trigger: 'blur' },
        ],
        height: [
          { validator: this.validateBillingRequired(1), trigger: 'blur' },
          { validator: this.validateNumberDecimal(2, this.$t('QuotationCenter.components.maxTwoDecimals')), trigger: 'blur' },
        ],
        PalletsNum: [
          { validator: this.validateBillingRequired(2), trigger: 'blur' },
          { validator: this.validatePositiveInteger, trigger: 'blur' },
        ],
        TicketsNum: [
          { validator: this.validateBillingRequired(3), trigger: 'blur' },
          { validator: this.validatePositiveInteger, trigger: 'blur' },
        ],
        HoursNum: [
          { validator: this.validateBillingRequired(4), trigger: 'blur' },
          { validator: this.validatePositiveInteger, trigger: 'blur' },
        ],
        ItemsNum: [
          { validator: this.validateBillingRequired(5), trigger: 'blur' },
          { validator: this.validatePositiveInteger, trigger: 'blur' },
        ],
        TimesNum: [
          { validator: this.validateBillingRequired(6), trigger: 'blur' },
          { validator: this.validatePositiveInteger, trigger: 'blur' },
        ],
        amount: [{ validator: this.validateNumberDecimal(2, this.$t('QuotationCenter.components.maxTwoDecimals')), trigger: 'blur' }],
      };
    },
    // 计算总金额
    totalAmountText() {
      const rows = Array.isArray(this.displayedRows) ? this.displayedRows : [];
      const total = rows.reduce((sum, row) => {
        const amount = Number(String(row.standardAmount || '').replace(/[^\d.-]/g, ''));
        return Number.isNaN(amount) ? sum : sum + amount;
      }, 0);
      const currency = (rows.find(row => row.standardCurrency) || {}).standardCurrency;
      return `${total.toFixed(2)}${currency ? ` ${currency}` : ''}`;
    },
  },
  mounted() {
    loadQuotationOptions().then(() => {
      if (!this.queryParams.feeItems || !this.queryParams.feeItems.length) {
        this.queryParams.feeItems = QUOTATION_FEE_ITEM.map(item => item.value);
      }
    });
    // 获取供应商列表
    logisticApi.getLogisticsCompany({}).then((res) => {
      if (!res.failed) {
        this.supplierAllList = (res.content || []).map(item => ({
          label: item.name,
          value: item.id,
        }));
      }
    });
    // 获取物流渠道列表
    logisticApi.getLogisticsBusiness({}).then((res) => {
      if (!res.failed) {
        this.logisticsChannelAllList = (res.content || []).map(item => ({
          label: item.name,
          value: item.id,
        }));
      }
    });
  },
  methods: {
    // 空值 -> 通过
    // 有值且匹配正则 -> 通过
    // 有值但不匹配 -> 格式错误
    validatePattern(pattern, message) {
      return (rule, value, callback) => {
        if (value === '' || value === null || value === undefined || pattern.test(String(value).trim())) {
          callback();
          return;
        }
        callback(new Error(message));
      };
    },
    // 校验数字小数位数
    validateNumberDecimal(maxDecimals, decimalMessage) {
      return (rule, value, callback) => {
        if (value === '' || value === null || value === undefined) {
          callback();
          return;
        }
        const text = String(value).trim();
        if (!NON_NEGATIVE_NUMBER_PATTERN.test(text)) {
          callback(new Error(this.$t('formatErrorText')));
          return;
        }
        const decimal = text.split('.')[1] || '';
        if (decimal.length > maxDecimals) {
          callback(new Error(decimalMessage));
          return;
        }
        callback();
      };
    },
    // 查询前校验表单
    validatePositiveInteger(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback();
        return;
      }
      if (POSITIVE_INTEGER_PATTERN.test(String(value).trim())) {
        callback();
        return;
      }
      callback(new Error(this.$t('formatErrorText')));
    },
    validateRequired(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error(this.$t('inputText')));
        return;
      }
      callback();
    },
    validateBillingRequired(type) {
      return (rule, value, callback) => {
        if (!this.isBillingTypeSelected(type)) {
          callback();
          return;
        }
        if (value === '' || value === null || value === undefined) {
          callback(new Error(this.$t('inputText')));
          return;
        }
        callback();
      };
    },
    getBillingTypeValues(value = this.queryParams.billingType) {
      const values = Array.isArray(value) ? value : [value];
      return values
        .filter(item => item !== '' && item !== null && item !== undefined)
        .map(item => Number(item))
        .filter(item => !Number.isNaN(item));
    },
    isBillingTypeSelected(type) {
      return this.getBillingTypeValues().includes(Number(type));
    },
    handleBillingTypeChange(value) {
      const selectedTypes = this.getBillingTypeValues(value);
      Object.keys(BILLING_FIELD_MAP).forEach(type => {
        const isSelected = selectedTypes.includes(Number(type));
        BILLING_FIELD_MAP[type].forEach(field => {
          if (!isSelected) {
            this.queryParams[field] = '';
          }
        });
      });
      if (selectedTypes.includes(3)) {
        this.queryParams.TicketsNum = '1';
      }
      this.$nextTick(() => {
        const form = this.getQueryForm();
        if (form && form.clearValidate) {
          form.clearValidate();
        }
      });
    },
    toBillingNumber(value) {
      const numberValue = Number(value);
      return Number.isNaN(numberValue) ? value : numberValue;
    },
    getBillingValue(type) {
      if (type === 0) {
        return this.toBillingNumber(this.queryParams.weight);
      }
      if (type === 1) {
        return Math.max(
          Number(this.queryParams.length),
          Number(this.queryParams.width),
          Number(this.queryParams.height),
        );
      }
      if (type === 2) {
        return this.toBillingNumber(this.queryParams.PalletsNum);
      }
      if (type === 3) {
        return 1;
      }
      if (type === 4) {
        return this.toBillingNumber(this.queryParams.HoursNum);
      }
      if (type === 5) {
        return this.toBillingNumber(this.queryParams.ItemsNum);
      }
      if (type === 6) {
        return this.toBillingNumber(this.queryParams.TimesNum);
      }
      return null;
    },
    buildTrialQueryParams(conditionObj) {
      const params = { ...conditionObj };
      params.city = params.city ? String(params.city).trim() : params.city;
      const billingTypes = this.getBillingTypeValues(params.billingType);
      params.billingItems = billingTypes.map(type => ({
        billingType: type,
        billingVal: this.getBillingValue(type),
      }));
      delete params.billingType;
      Object.values(BILLING_FIELD_MAP).flat().forEach(field => {
        delete params[field];
      });
      params.weight = this.queryParams.weight;
      params.length = this.queryParams.length;
      params.width = this.queryParams.width;
      params.height = this.queryParams.height;
      return params;
    },
    getQueryForm() {
      return this.$refs.BjPage && this.$refs.BjPage.$refs.BjForm && this.$refs.BjPage.$refs.BjForm.$refs.queryForm;
    },
    beforeQuerySearch(conditionObj) {
      const form = this.getQueryForm();
      if (this.isResettingSearch) {
        this.isResettingSearch = false;
        if (this.$refs.BjPage) {
          this.$refs.BjPage.loading = false;
        }
        this.$nextTick(() => {
          if (form && form.clearValidate) {
            form.clearValidate();
          }
        });
        return new Promise(() => {});
      }
      if (!form) return Promise.resolve(conditionObj);
      return new Promise((resolve) => {
        form.validate((valid) => {
          if (!valid && this.$scrollToFormError) {
            this.$scrollToFormError();
          }
          if (!valid && this.$refs.BjPage) {
            this.$refs.BjPage.loading = false;
          }
          if (valid) {
            resolve(this.buildTrialQueryParams(conditionObj));
          }
        });
      });
    },
    clearTrialResult() {
      this.displayedRows = [];
      const page = this.$refs.BjPage;
      if (page) {
        page.tableData = [];
        page.filterTableData = null;
        page.pagingInfo.total = 0;
      }
    },
    // 重置查询表单前的处理
    beforeResetSearch() {
      this.isResettingSearch = true;
      this.clearTrialResult();
      return Promise.resolve();
    },
    // 计算总金额使用
    afterFetchData(res) {
      this.displayedRows = Array.isArray(res) ? res : [];
    },
  },
};
</script>

<style lang="scss" scoped>
.trial-search-spacer {
  min-height: 1px;
}

.trial-total {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  padding: 12px 32px;
  font-size: 14px;
}

.trial-total strong {
  color: #b45309;
  font-size: 18px;
}

.trial-required-label::before {
  content: '*';
  margin-right: 4px;
  color: #f56c6c;
}
</style>
